import React, { useState, useEffect } from 'react';
import ReactJoyride, { CallBackProps, STATUS, Step } from 'react-joyride';
import { useAuth, UserContextType } from '../auth';
import { useTheme } from '@mui/material/styles';

const StreamingTour: React.FC = () => {
    const { IsAuthenticated } = React.useContext<UserContextType>(useAuth);
    const [run, setRun] = useState(false);
    const theme = useTheme();

    useEffect(() => {
        // Start the tour when the component mounts
        // We can add logic here to check if the user has already seen the tour using localStorage or similar
        const tourSeen = localStorage.getItem('chat_tour_seen');
        if (!tourSeen) {
            setRun(true);
        }
    }, []);

    const handleJoyrideCallback = (data: CallBackProps) => {
        const { status } = data;
        const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            setRun(false);
            localStorage.setItem('chat_tour_seen', 'true');
        }
    };

    const isAuthenticated = IsAuthenticated && IsAuthenticated();

    const steps: Step[] = [
        {
            target: '#chat-fab',
            content: isAuthenticated
                ? "Join the community! Click here to fellowship, share prayer requests, and chat with others during the service."
                : "Experience community from anywhere! Create an account to join the live chat, fellowship with others, and participate in the service.",
            disableBeacon: true,
            placement: 'top-end',
            spotlightPadding: 20,
            styles: {
                options: {
                    zIndex: 10000,
                    primaryColor: theme.palette.primary.main,
                }
            }
        }
    ];

    return (
        <ReactJoyride
            steps={steps}
            run={run}
            continuous
            showSkipButton
            showProgress
            locale={{
                last: "Okay",
                skip: "Skip"
            }}
            styles={{
                options: {
                    zIndex: 10000,
                },
                buttonNext: {
                    backgroundColor: theme.palette.secondary.main,
                }
            }}
            callback={handleJoyrideCallback}
        />
    );
};

export default StreamingTour;
